import React, { useState } from 'react';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import draftToHtml from 'draftjs-to-html';

export default function HtmlEditor(props) {
    const [ editorState, setEditorState ] = useState(EditorState.createEmpty());
    const { onHtmlEditorStateChange } = props;

  const handleEditorStateChange = (editorState) => {
    setEditorState(editorState);
    onHtmlEditorStateChange(draftToHtml(convertToRaw(editorState.getCurrentContent())));
  };

  return (
    <Editor
        editorState={editorState}
        onEditorStateChange={handleEditorStateChange}
        toolbar={ 
            {
                options: ['inline','fontSize', 'fontFamily','colorPicker'],
                inline: {
                options: ['bold', 'italic', 'underline']
                },
                fontSize: {
                options: [18, 24, 36, 48, 72],
                }
            }
        }
        handleReturn={(e) => {
            e.preventDefault();
            document.execCommand("insertLineBreak");
            return true;
        }}
    />
  );
}